import { useContext } from 'react';
import {
  useInventoryIsLoaded,
  useInventoryVehicles
} from '~/context/srp/InventoryContext';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';

export function useSuggestedFilters() {
  return useContext(SuggestedFiltersContext).suggestedFilters.data;
}

export function useShowSuggestedFilters() {
  const { suggestedFilters } = useContext(SuggestedFiltersContext);
  const isInventoryLoaded = useInventoryIsLoaded();
  const inventoryVehicles = useInventoryVehicles();

  return (
    !suggestedFilters.hasError &&
    (inventoryVehicles.length > 0 || !isInventoryLoaded)
  );
}

export function useIsSuggestedFiltersLoaded() {
  const { suggestedFilters } = useContext(SuggestedFiltersContext);
  const isInventoryLoaded = useInventoryIsLoaded();

  return isInventoryLoaded && suggestedFilters.isLoaded;
}

export function useSuggestedFiltersEmpty() {
  const { suggestedFilters } = useContext(SuggestedFiltersContext);
  const isSuggestedFiltersLoaded = useIsSuggestedFiltersLoaded();
  const showSuggestedFilters = useShowSuggestedFilters();

  return (
    !showSuggestedFilters ||
    (isSuggestedFiltersLoaded && suggestedFilters.data.length === 0)
  );
}
